import React, { useState } from 'react';
import './FAQ.scss';
import { CONTACTS } from '../../config/contacts';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
  {
    id: 1,
    question: "O sistema é fácil de usar mesmo para quem não entende de tecnologia?",
    answer:
      "Sim. O 77Gestão foi criado para ser simples, direto e intuitivo. Além disso, você conta com suporte humano para te ajudar em cada etapa, caso precise."
  },
  {
    id: 2,
    question: "O que está incluso no teste grátis?",
    answer:
      "Durante os 7 dias de teste, você tem acesso a todas as funcionalidades liberadas, sem limitações, sem pedir cartão de crédito e sem compromisso."
  },
  {
    id: 3,
    question: "Preciso instalar alguma coisa no meu computador?",
    answer:
      "Não. O sistema funciona 100% online e pode ser acessado de qualquer dispositivo com internet, sem necessidade de instalação."
  },
  {
    id: 4,
    question: "Como funciona a emissão de NFe e NFS-e?",
    answer:
      "Você pode emitir notas fiscais de forma simples, com um passo a passo guiado. Suportamos NFe e NFS-e para São Paulo (capital) e municípios atendidos pelo padrão Ginfes/Gissonline, para os demais municipios entre em contato com a equipe técnica."
  },
  {
    id: 5,
    question: "Posso cancelar quando quiser?",
    answer:
      "Sim. Você pode cancelar seu plano a qualquer momento, sem multa e sem burocracia."
  },
  {
    id: 6,
    question: "Vocês oferecem suporte? Como funciona?",
    answer:
      "Sim. Nosso suporte é rápido, humano e disponível para te ajudar via WhatsApp sempre que precisar."
  },
  {
    id: 7,
    question: "Para quais tipos de empresa o 77Gestão é ideal?",
    answer:
      "O sistema é ideal para empresas do Simples Nacional que precisam organizar vendas, financeiro, estoque e emitir notas."
  },
  {
    id: 8,
    question: "O sistema é seguro? Meus dados ficam protegidos?",
    answer:
      "Sim. Utilizamos servidores seguros, backups automáticos e criptografia para manter todas as suas informações protegidas."
  }
];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq">
      <div className="faq-container">
        <div className="faq-header">
          <h2>Perguntas Frequentes</h2>
          <p>Tire suas dúvidas sobre o 77Gestão</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={faq.id} 
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
            >
              <button 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <i className={`fas fa-chevron-${openIndex === index ? 'up' : 'down'}`}></i>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <p>Ainda tem dúvidas?</p>
          <a href={CONTACTS.whatsapp.getUrl('Olá, tenho uma dúvida sobre o 77Gestão')} className="faq-cta" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-whatsapp"></i>
            Fale com nosso suporte
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
